export enum INSTANCE_COPY {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=53170296
     */
    COPY = 'ADMIN.NAV.INSTANCES.COPY',
}
